/* =========================================================
   Tool 2：人格描述代理
   輸入：mbtiType（例如 "INFP"）
   輸出：{ name, desc } 人格名稱與描述
========================================================= */

const PERSONALITY_MAP = {
  INTJ: {
    name: '孤獨的旋律建築師',
    desc: '你用理性解構每一首歌，從編曲到歌詞都有你自己的評分標準。你不追流行，只追那些真正打動你內心深處的作品。',
  },
  INTP: {
    name: '音符邏輯探索者',
    desc: '你喜歡挖掘冷門神曲，享受發現別人還沒聽過的寶藏。對你來說，聽音樂是一場永無止境的知識探索之旅。',
  },
  ENTJ: {
    name: '強勢的聽覺掌控者',
    desc: '你的歌單像是一份精心規劃的策略清單。你喜歡有力量感的音樂，需要它在你征服每一天時為你提供燃料。',
  },
  ENTP: {
    name: '反叛的聲音獵人',
    desc: '你永遠在挑戰主流，喜歡那些有點奇怪、有點挑釁的音樂。你的歌單讓別人摸不透，但你就是愛這種感覺。',
  },
  INFJ: {
    name: '靈魂共鳴的追尋者',
    desc: '你把每首歌當成一面鏡子，尋找那些能說出你說不出口的感受的旋律。音樂對你來說是靈魂的語言，不只是娛樂。',
  },
  INFP: {
    name: '迷霧中的旋律漫遊者',
    desc: '你是個用音樂做夢的人。一首歌能讓你在腦海裡展開整部電影，你永遠在尋找那首能讓你淚崩的完美歌曲。',
  },
  ENFJ: {
    name: '溫暖的音樂傳遞者',
    desc: '你聽音樂是為了分享。你總是第一個說「你一定要聽這首！」的人，因為你相信對的音樂能改變一個人的一天。',
  },
  ENFP: {
    name: '跳躍感性的音浪衝浪者',
    desc: '你的心情決定你的歌單，而你的心情每小時都在變。你活在音樂的當下，每首歌都是一次全新的冒險。',
  },
  ISTJ: {
    name: '穩定忠實的老派聆聽者',
    desc: '你有固定的歌單，某些歌你已經聽了幾百遍還不夠。對你來說，熟悉的旋律就是最好的陪伴，可靠又安心。',
  },
  ISFJ: {
    name: '懷舊溫柔的記憶守護者',
    desc: '每首歌背後都有一段你珍藏的回憶。你喜歡能讓心情平靜下來的溫柔旋律，像一杯熱茶陪你度過每個普通的夜晚。',
  },
  ESTJ: {
    name: '效率至上的節奏執行者',
    desc: '你用音樂提升效率。工作時、運動時、通勤時，你都有對應的歌單。你不浪費時間猶豫，直接播最有效果的那首。',
  },
  ESFJ: {
    name: '人氣榜單的快樂跟隨者',
    desc: '你喜歡那些讓大家都能一起唱的歌。流行榜上的金曲是你的最愛，因為音樂就是要一起分享才有意義！',
  },
  ISTP: {
    name: '冷靜酷感的獨立聽眾',
    desc: '你不需要別人推薦，自己挖歌比任何算法都準。你偏好有質感、不做作的音樂，酷感是你選歌的唯一標準。',
  },
  ISFP: {
    name: '細膩敏感的美感體驗者',
    desc: '你用全身感受音樂。一首歌的聲音質地、人聲的顆粒感，都能讓你沉浸其中。你聽的不只是音樂，是一種藝術體驗。',
  },
  ESTP: {
    name: '當下燃燒的能量爆發者',
    desc: '你需要讓你動起來的音樂！節奏強、Bass 重、讓你忍不住點頭的那種。你聽音樂就是要感受當下最大的刺激。',
  },
  ESFP: {
    name: '派對靈魂的快樂製造機',
    desc: '你走到哪裡音樂就跟到哪裡。你是那個會突然在客廳開始跳舞的人，因為對你來說，生活本身就是一場演唱會。',
  },
};

export function personalityTool(mbtiType) {
  return PERSONALITY_MAP[mbtiType] || PERSONALITY_MAP['INFP'];
}
